import CountUp from "react-countup";
import React, {useEffect, useState} from 'react';
import BackButton from "../../../Components/BackButton";
import TitlePages from "../../../Components/TitlePages";
import axios from 'axios';
import {
  Container,
  SizeContainer,
  Title,
  MainContainer,
  ButtonsDiv,
  ButtonCompanies,
  ButtonDeleteCompanies,
  ButtonAddCompanies,
  RoundsNBlackout,
  InfoMain,
  InfoDiv,
  ButtonRequest,
  InputAddIndustry,
  UserDiv,
  ListPlayers
} from "./styles";
import { __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED } from "react-dom/cjs/react-dom.development";

const SetupIndustry = () => {

  const [produtos, setProdutos] = useState([])
  const [insumos, setInsumos] = useState([])
  const [showInputToAddIndustry, setShowInputToAddIndustry] = useState(false)
  const [showLista, setShowLista] = useState(false)
  const [idProduto, setIdProduto] = useState(0)
  const [listaPlayers, setListaPlayers] = useState(null)
  const [produtoCusto, setProdutoCusto] = useState(null)
  const [produtoPreco, setProdutoPreco] = useState(null)
  const [produtoPerda, setProdutoPerda] = useState(null)
  const [selectedInsumo, setSelectedInsumo] = useState('')
  const [insumosQuantity, setInsumosQuantity] = useState('')
  const [estoqueInicial, setEstoqueInicial] = useState('')
  const [produtoUnidade, setProdutoUnidade] = useState('')

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  function deleteInsumoInProduct(id) {

    api.post(
      `/api/produto/apagarInsumo/3`
    )
    .then(response => console.log(response))
    .catch(error => {
      return Promise.reject(error)
    })
  }

  //lista todos os jogadores da industria
  function listAllProdutos(produto) {

    if(produto.produto != idProduto) {
      setProdutoCusto('')
      setProdutoPerda('')
      setEstoqueInicial('')
      setProdutoUnidade('')
      setProdutoPreco('')
      setShowLista(!showLista)
    }

    setIdProduto(produto.produto)

    try {
      api.get("/api/insumo/listarTodos")
      .then(response => setInsumos(response.data))
    } catch(error) {
      console.log(error)
    }
    
    // setShowAllUsers(false)

    api.get(`/api/produto/listarInsumos/${produto.produto}`)
    .then(response => setListaPlayers(response.data))
    .catch(error => {
      return Promise.reject(error)
    })

    setShowLista(!showLista)

   
  }

  function addInsumoToProduct(produto) {

    const data = {
        "insumo": {
          "estoque": 0,
          "insumo": selectedInsumo,
          "nome": "",
          "urlImagem": ""
        },
        "produto": idProduto,
        "produtoInsumo": 0,
        "quantidade": insumosQuantity
      }
   

    api.post(`/api/produto/adicionarInsumo`, data)
    .then(response => console.log(response.data))
    .catch(error => {
      return Promise.reject(error)
    })

    try {
      api.get(`/api/produto/listarInsumos/${produto.produto}`)
      .then(response => setListaPlayers(response.data))
    } catch(e) {
      return Promise.reject(e)
    }

    
    
  }

  function addNewProduct(produto) {
    const data = {
        "custo": produtoCusto ? produtoCusto : produto.custo,
        "estoque": estoqueInicial ? estoqueInicial : produto.estoque,
        "nome": produto.nome,
        "preco": produtoPreco ? produtoPreco : produto.preco,
        "previsaoPerda": produtoPerda ? produtoPerda : produto.previsaoPerda,
        "produto": produto.produto,
        "unidadeVenda": produtoUnidade ? produtoUnidade : produto.unidadeVenda,
        "urlImagem": ""
      }

    api.post("/api/produto/cadastrar", data)
      .then(response => console.log(response))

     

    setProdutoCusto('')
    setProdutoPerda('')
    setEstoqueInicial('')
    setProdutoUnidade('')
    setProdutoPreco('')

    setShowInputToAddIndustry(false)
  }

  function deleteIndustry(id, nameIndustry) {

    const data = {
      "industria": id,
      "nome": nameIndustry
    }

    api.delete(
      "/api/industria/apagar",
      data
    )
    .then(response => console.log(response))
    .catch(error => {
      return Promise.reject(error)
    })
  }

  useEffect(() => {

    api.get("/api/produto/listarTodos")
      .then(response => setProdutos(response.data))
      .catch(error => {
          return error
      })
    
  }, [api])


  return (
    <Container>
      <SizeContainer>
        <TitlePages text="Setup Indústria" />
        <BackButton path="/menuIndustry" />
        <Title>
          Número de produtos <span>{produtos?.length}</span>
        </Title>
        <MainContainer>

          {produtos?.map((produto, k) => {

            return (
            <div key={k}>

              <ButtonsDiv>
                <ButtonCompanies onClick={() => listAllProdutos(produto)} >{produto.nome}</ButtonCompanies>
                <ButtonDeleteCompanies onClick={() => deleteIndustry(produto.produto, produto.nome)} >X</ButtonDeleteCompanies>
              </ButtonsDiv>

              {
                showLista && produto.produto === idProduto ? (
              
                
                  <UserDiv>

          <InfoMain>
            <InfoDiv>
              <p>Unidade de Venda:</p>
           
              <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={produtoUnidade} onChange={(e) => setProdutoUnidade(e.target.value)}  placeholder={"Caixa de " + produto.unidadeVenda + " kg"} type="text" />
            
          </ButtonCompanies>
    
            </InfoDiv>
            <InfoDiv>
              <p>Estoque Inicial:</p>
              <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={estoqueInicial} onChange={(e) => setEstoqueInicial(e.target.value)} placeholder={produto.estoque + " kg"} type="number" /></ButtonCompanies>
        
            </InfoDiv>
            <InfoDiv>

              <p>Custo Unitário:</p>
              <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={produtoCusto} onChange={(e) => setProdutoCusto(e.target.value)} placeholder={"R$ " + produto.custo} type="number" /></ButtonCompanies>
           
            </InfoDiv>
            <InfoDiv>

              <p>Preço:</p>
              <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={produtoPreco} onChange={(e) => setProdutoPreco(e.target.value)} placeholder={"R$ " + 0} type="number" /></ButtonCompanies>
       
            </InfoDiv>
            <InfoDiv>
              <p>Previsão de Perda:</p>
              <ButtonCompanies style={{background: "#fff"}}><InputAddIndustry value={produtoPerda} onChange={(e) => setProdutoPerda(e.target.value)} placeholder={produto.previsaoPerda + "%"} type="number" /></ButtonCompanies>
         
            </InfoDiv>

            <div style={{display: "flex", width: "100%", justifyContent: "center"}}>
              <ButtonCompanies style={{color: "orange", background: "#fff"}} onClick={() => addNewProduct(produto)} >Atualizar Produto</ButtonCompanies>
            </div>
            
            
          </InfoMain>

                 


               
                  </UserDiv>
              
                
                ) : (<></>)
              }
                       
            </div>
            )
          })}

          
          <ButtonRequest>EXPORTAR</ButtonRequest>
        </MainContainer>
      </SizeContainer>
    </Container>
  );
};
export default SetupIndustry;
